import { createClient } from '@supabase/supabase-js';

// LinkSanto public renderer — anon-only client.
// Hardcoded STAGING fallback (ref: vmuwmalmsemtvuoyrfeh). This file is only
// bundled into the LinkSanto renderer (santo-links Amplify app), which serves
// staging.me.linksanto.io. We deliberately ship a staging fallback so that a
// missing build-time env var on Amplify cannot blank-screen the public pages.
// We NEVER ship a production fallback here.
const STAGING_URL = 'https://vmuwmalmsemtvuoyrfeh.supabase.co';
const STAGING_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZtdXdtYWxtc2VtdHZ1b3lyZmVoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc3Njk2MjQsImV4cCI6MjA5MzM0NTYyNH0.J_N0SEzILFRJCI0fryJ6KzytJPMJQAVhvALmHncSbQg';

const ENV_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const ENV_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabaseUrl = ENV_URL || STAGING_URL;
export const supabaseAnonKey = ENV_KEY || STAGING_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
});

export const supabaseReady = true;
